const Flickity = require('flickity');
import findAncestor from "./findAncestor";

export default () => {

    const pathwaySlides = document.querySelectorAll('[data-pathways]');
    const pathways = document.querySelectorAll('.pathway');

    let sliders = [];

    const init = () => {
        for (const pathwaySlide of pathwaySlides) {
            const flickity = new Flickity(pathwaySlide, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
                pageDots: true,
                // autoPlay: 5000
            });
            sliders.push(flickity);
        }

        for (const pathway of pathways) {
            pathway.addEventListener('click', () => {
                const index = parseInt(pathway.getAttribute('data-count')) - 1;
                const container = findAncestor(pathway, '[data-pathway-container]');
                const popup = container.querySelector('.popup');
                const slider = container.querySelector('[data-pathways-mobile]');
                const prev = container.querySelector('[data-prev]');
                const next = container.querySelector('[data-next]');
                const closeBtns = container.querySelectorAll('.close');

                popup.classList.add('active');
                const flickity = new Flickity(slider, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    pageDots: false,
                    initialIndex: index
                });

                next.addEventListener('click', (e) => {
                    e.preventDefault();
                    flickity.next();
                });
                prev.addEventListener('click', (e) => {
                    e.preventDefault();
                    flickity.previous();
                });
                for (const close of closeBtns) {
                    close.addEventListener('click', (e) => {
                        e.preventDefault();
                        destroyPopup(flickity, popup, next, prev, close);
                    });
                }

            });
        }
    }

    const destroyPopup = (flickity, popup, next, prev, close) => {
        flickity.destroy();
        popup.classList.remove('active');
        next.removeEventListener('click');
        prev.removeEventListener('click');
        close.removeEventListener('click');
    }

    const destroy = () => {
        if (sliders.length) {
            for (const slider of sliders) {
                slider.destroy();
            }
        }
        sliders = [];

        for (const pathway of pathways) {
            // pathway.removeEventListener('click');
        }
    }

    const check = () => {
        if (window.innerWidth < 768) {
            init();
        } else {
            destroy();
        }
    }


    if (pathways.length) {
        check();
        window.addEventListener('resize', () => {
            check();
        });
    }

}
